import { Injectable } from '@angular/core';

@Injectable()
export class WidgetLibraryService {
	private _scrollBarWidth: number;

	constructor() {
		this.calculateScrollWidth();
	}

	get scrollBarWidth(): number {
		return this._scrollBarWidth;
	}

	set scrollBarWidth(value: number) {
		this._scrollBarWidth = value;
	}

	/**
	 * 	### To calculate scrollWidth https://stackoverflow.com/questions/8079187/how-to-calculate-the-width-of-the-scroll-bar/8079681#8079681
	 */
	calculateScrollWidth(): void {
		const inner = document.createElement('p');
		inner.style.width = '100%';
		inner.style.height = '200px';

		const outer = document.createElement('div');
		outer.style.position = 'absolute';
		outer.style.top = '0px';
		outer.style.left = '0px';
		outer.style.visibility = 'hidden';
		outer.style.width = '200px';
		outer.style.height = '150px';
		outer.style.overflow = 'hidden';
		outer.appendChild(inner);

		document.body.appendChild(outer);
		const w1 = inner.offsetWidth;
		outer.style.overflow = 'scroll';
		let w2 = inner.offsetWidth;
		if (w1 === w2) {
			w2 = outer.clientWidth;
		}

		document.body.removeChild(outer);
		this.scrollBarWidth = w1 - w2;
	}
}
